<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19.972">
    <path clip-rule="evenodd" d="M15.84 9.092H4.31c-.46 0-.833-.407-.833-.908 0-.501.373-.908.833-.908h11.53c.46 0 .833.407.833.908 0 .501-.374.908-.834.908zM15.84 12.539H4.31c-.46 0-.833-.407-.833-.908 0-.5.373-.907.833-.907h11.53c.46 0 .833.407.833.907 0 .501-.374.908-.834.908zM15.84 15.985H4.31c-.46 0-.833-.406-.833-.906 0-.502.373-.908.833-.908h11.53c.46 0 .833.406.833.908 0 .5-.374.906-.834.906z"/>
    <path d="M17.5 0h-15C1.122 0 0 1.221 0 2.724v14.524c0 1.501 1.122 2.724 2.5 2.724h15c1.378 0 2.5-1.223 2.5-2.724V2.724C20 1.221 18.878 0 17.5 0zm0 18.156h-15c-.46 0-.833-.407-.833-.908V4.538h16.666v12.71c0 .501-.374.908-.833.908z"/>
    </svg>
</template>

<script>
export default {}
</script>
